var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-star"},[_c('vueHeader',{on:{"getClass":_vm.getClass}}),_c('vueContent'),_c('vueFooter',{attrs:{"className":_vm.className}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }